import React from "react";
import { Route, Switch } from "react-router";
import { BrowserRouter as Router } from "react-router-dom";
import { Refreshable } from "react-router-refreshable";
import ProtectedRoute from "./components/containers/auth/ProtectedRoute";
import HomePage from "./components/containers/HomePage";
import LoginInPage from "./components/containers/LoginPage";
import LoadingSpinnerComponent from "./components/loding/LoadingSpinnerComponent";
import { useAuth } from "./components/providers/AuthProvider";

const AuthorizationContainer: React.FC = () => {
  const { isLoading } = useAuth();

  return !isLoading ? (
    <>
      <Router>
        <Refreshable>
          <Switch>
            <ProtectedRoute path="/home" component={HomePage} />
            <Route path="/" component={LoginInPage} />
            <Route path="/login" component={LoginInPage} />
          </Switch>
        </Refreshable>
      </Router>
    </>
  ) : (
    <>
      <LoadingSpinnerComponent />
    </>
  );
};

export default AuthorizationContainer;
